export default __webpack_public_path__ + "static/media/DNo.32-5.fb173e81.jpg";